import { useEffect } from "react";

// Global counter to track multiple modals
let lockCount = 0;
let originalOverflow = "";
let originalPaddingRight = "";

/**
 * Custom hook to prevent body scrolling when modal/overlay is open
 * @param {boolean} isOpen - Whether the modal/overlay is open
 */
export const useScrollLock = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      lockCount++;

      // Only lock scroll on first modal
      if (lockCount === 1) {
        // Store original body style
        const originalStyle = window.getComputedStyle(document.body);
        originalOverflow = originalStyle.overflow;
        originalPaddingRight = originalStyle.paddingRight;

        // Calculate scrollbar width
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;

        // Apply styles to prevent scrolling
        document.body.style.overflow = "hidden";

        // Compensate for scrollbar width to prevent layout shift
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${
            parseInt(originalPaddingRight, 10) + scrollbarWidth
          }px`;
        }
      }

      // Cleanup function
      return () => {
        lockCount--;

        // Only unlock scroll when all modals are closed
        if (lockCount === 0) {
          document.body.style.overflow = originalOverflow;
          document.body.style.paddingRight = originalPaddingRight;
        }
      };
    }
  }, [isOpen]);
};

export default useScrollLock;
